var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.systemStarted === null)?_c('div',{staticClass:"loader"},[_c('loader-component',{attrs:{"size":"lg"}})],1):(_vm.systemStarted)?_c('router-view'):_c('plug-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }